// hooks/useEvents.js
import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import UpshowLogger from '../Logger';
import getHeaders from '../utils/getHeaders';

const BASE_URL= process.env.REACT_APP_REST_URL;

export default function useEvents(inactive) {
  const [liveEvents,      setLiveEvents]      = useState([]);
  const [upcomingEvents,  setUpcomingEvents]  = useState([]);
  const [scheduledEvents, setScheduledEvents] = useState([]);
  const [complete,        setComplete]        = useState([]);
  const [loading,         setLoading]         = useState(false);

  /** Fetch once (or on demand) */
  const fetchEvents = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${BASE_URL}/v6/events`, {
        headers: { ...getHeaders(), 'Cache-Control': 'no-cache' },
        params : { _: Date.now() },
      });
      setLiveEvents(     data.events.filter(ev => ev.status === 'LIVE'));
      setUpcomingEvents( data.events.filter(ev =>
        (ev.status === 'SCHEDULED' || ev.status === 'COMING') && !ev.isDeviceSubscribed));
      setScheduledEvents(data.events.filter(ev =>
        ev.status === 'SCHEDULED' && ev.isDeviceSubscribed));
      setComplete(data.events);
    } catch (err) {
      UpshowLogger.error(['events'], err);
    } finally {
      setLoading(false);
    }
  }, []);
  /** Poll when the UI is active */
  useEffect(() => {
    if (inactive) return;          // pause when inactive
    fetchEvents();                 // immediate fetch
  }, [inactive, fetchEvents]);

  return {
    loading,
    liveEvents,
    upcomingEvents,
    scheduledEvents,
    completeLiveEvents: complete,
    fetchEvents,                   // expose for manual calls
  };
}
